module.exports = __webpack_public_path__ + "img/p7.c3f27a8e.jpg";